
import axios from "axios";
import { UserData, UserInformation } from "models/auth.model";
import { Address } from "models/domain/address.domain";
import { Cpf } from "models/domain/cpf.domain";
import { Email } from "models/domain/email.domain";
import { PhoneNumber } from "models/domain/phoneNumber.domain";
import { Zipcode } from "models/domain/zipcode.domain";
import { removeMasks } from "utils/remove-masks";
import api from "_config/api";

export class AuthAPI {
    static async login(cpf: string, password: string): Promise<UserData> {
        cpf = removeMasks(cpf);
        const response = await axios.post<UserData>(`${process.env.REACT_APP_API}/auth/login`, { cpf, password });
        return response.data;
    }

    static async getProfileData(): Promise<UserInformation> {
        const token = this.getRefreshToken();
        if (!token) {
            throw new Error('Token inválido.');
        }
        
        const response = await api.get(`/me`);        
        const birthDate = new Date(`${response.data.dataNascimento.split('/').reverse().join('-')}T23:59`);
        return {
            id: response.data.id,
            name: response.data.nome,
            roles: response.data.roles,
            email: Email.fromString(response.data.email).toString(),
            cpf: Cpf.fromString(response.data.cpf).getWithMask(),
            phoneNumber: PhoneNumber.fromString(response.data.telefone).getWithMask(),
            birthDate,
            address: new Address(
                response.data.endereco.uf,
                response.data.endereco.municipio,
                response.data.endereco.bairro,
                response.data.endereco.logradouro,
                response.data.endereco.tipoLogradouro,
                response.data.endereco.numero,
                response.data.endereco.complemento,
                response.data.endereco.cep ? Zipcode.fromString(response.data.endereco.cep) : undefined
            )
        };
    }

    static async refreshToken(): Promise<UserData> {
        const token = this.getRefreshToken();
        if (!token) {
            throw new Error('Token inválido.');
        }
        const formData = new FormData();
        formData.append('refreshToken', token);
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
        const response = await api.post<UserData>(`/auth/refresh-token`, formData, { headers });
        return response.data;
    }

    private static getRefreshToken() {
        const data = JSON.parse((localStorage.getItem('@EGL/user-token') ?? 'null')) as UserData | null;

        if (!data?.refreshToken) {
            return undefined;
        }

        return data.refreshToken;
    }
}